import { NewConversationPayload } from '../../types/Messaging/NewConversationPayload';
import { request } from '../../utils/request';

export const createNewConversation = (
  formData: NewConversationPayload,
  authToken: string
) =>
  request({
    method: 'POST',
    url: `/messaging/conversations`,
    formData,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
